import VimeoPlayer from '@vimeo/player';



// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
        if (document.readyState === 'complete') {
            resolve(document);
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                resolve(document);
            });
        }
    });
};

document.ready().then(function () {

    const closeModalButtons = document.querySelectorAll('[data-close]');
    const openModalButtons = document.querySelectorAll('[data-open]');

    for (const $button of closeModalButtons) {

        const $modal = $button.closest('.reveal');

        if ($modal) {
            const $video = $modal.querySelector('video');

            if ($video) {
                
                $button.addEventListener('click', (event) => {
                    $video.pause();
                });
                
            }
        }

    }

    for (const $button of openModalButtons) {
        const $modal = document.getElementById($button.dataset.open);

        if ($modal) {
            const $video = $modal.querySelector('video');
            
            if ($video) {
                
                $button.addEventListener('click', (event) => {
                    $video.play();
                });
                
            }
        }
    }


});